/**
 * Calendar panel mode machine (collapsed | normal | expanded).
 *
 * Chrome geometry for the floating calendar lives in App.css
 * (`.calendar-floating-bl`, `.calendar-side-header`, RBC toolbar) and
 * uses `--nedi-radius-*` tokens (nedi-telas 1.4). This module owns
 * mode transitions only — not visual chrome.
 *
 * Modes: 'collapsed' | 'normal' | 'expanded'
 *   - collapsed: chip flutuante (padrão mobile; opcional em web/desktop)
 *   - normal: coluna lateral fixa (padrão web/desktop, painel mobile aberto)
 *   - expanded: overlay até 80% da tela
 *
 * Transições:
 *   - collapsed → normal
 *   - normal    → collapsed
 *   - normal    → expanded
 *   - expanded  → normal
 *   - expanded  → collapsed (via collapse action)
 */

export const CALENDAR_PANEL_MODES = Object.freeze(['collapsed', 'normal', 'expanded']);
export const PANEL_COLLAPSED = CALENDAR_PANEL_MODES[0];
export const PANEL_NORMAL = CALENDAR_PANEL_MODES[1];
export const PANEL_EXPANDED = CALENDAR_PANEL_MODES[2];

export function getNextCalendarPanelMode(current, action) {
  const transitions = {
    collapsed: { toggle: PANEL_NORMAL },
    normal:    { toggle: PANEL_COLLAPSED, expand: PANEL_EXPANDED },
    expanded:  { expand: PANEL_NORMAL, collapse: PANEL_COLLAPSED },
  };

  if (!transitions[current] || !transitions[current][action]) {
    return current;
  }

  return transitions[current][action];
}
